module.exports = __webpack_public_path__ + "static/img/genomics_clusters_3.ff462d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/genomics_clusters_3.png
// module id = 5DtV
// module chunks = 6